<div class="meet-to-info dsp-meet-to-info dspdp-text-center" *ngIf="availSugUser  && !loader">
    <div>
        <div class="image-box dspdp-spacer-md dsp-meetme-image">
            <a (click)="view_member(suggestionUser?.username)"> <img decoding="async"
                    [src]="suggestionUser?.profile_pic">
            </a>
        </div>
        <div class="user-meetto-info dspdp-font-2x  dspdp-spacer-md dsp-meet-details">
            <div class="user-name">
                <span class="dspdp-medium">{{suggestionUser?.username}}</span>
            </div>
            <div class="user-info">
                <span *ngIf="suggestionUser?.age">{{ suggestionUser?.age}}</span>
                <span *ngIf="suggestionUser?.city.length !== 0">, {{ suggestionUser?.city?.[0]?.name }}</span>
                <span *ngIf="suggestionUser?.state.length !== 0">, {{ suggestionUser?.state?.[0]?.name }}</span>
                <span *ngIf="suggestionUser?.country.length !== 0">, {{ suggestionUser?.country?.[0]?.name }}</span>
                <!-- <span *ngIf="!suggestionUser?.city?.[0]?.name && !suggestionUser?.state?.[0]?.name && !suggestionUser?.country?.[0]?.name">-</span>                 -->
            </div>
        </div>
        <h2>Want To Connect?</h2>
        <div class="wpee-meetme-action-wrap" data-current-user-id="1830" data-profile-id="5">
            <a class="button wpee-meet-me-trigger" data-action="no" (click)="ignoreSugUsder()">
                <fa-icon [icon]="faaclose"></fa-icon>No </a>
            <a class="button wpee-meet-me-trigger" data-action="yes" (click)="acceptSugUser()">
                <fa-icon [icon]="faheart"></fa-icon>Yes </a>

        </div>
    </div>
</div>
<div class="sug_user" [ngClass]="{ 'shine': loader }">
</div>